/* Contracts.tsx
    Une page affichant la gestion des contrats
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les éléments
    Utilise l'API correspondante pour les opérations de données
*/

import { faRepeat } from '@fortawesome/free-solid-svg-icons';
import { ContractsCrudCard } from 'features/contracts/components/ContractsCrudCard';
import PageHeader from 'layout/PageHeader';

export const Contracts = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faRepeat}
			title="Contrats fournisseurs"
			subtitle="Gérez les contrats avec vos fournisseurs"
		/>
		<ContractsCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
